import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { translate } from 'react-i18next';

import { trackAppDownload } from '../utils/analytics';
import Header from '../containers/PublicRouteHeader';
import Footer from '../containers/PublicRouteFooter';
import apkBadgeImg from '../images/apk-badge.svg';

import '../css/androidDownload.css';

const APK_URL =
  'https://s3.eu-north-1.amazonaws.com/co.psngr.android/psngr_4_11_2.apk';

const AndroidDownloadPage = ({ t }) => (
  <React.Fragment>
    <Helmet>
      <title>{t('androidDownload.pageTitle')}</title>
      <link
        rel="canonical"
        href={`${process.env.REACT_APP_base_url}/android-download`}
      />
    </Helmet>
    <Header />
    <div className="androidDownloadPage">
      <div className="androidDownloadContainer">
        <div className="androidDownloadBadge">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/d/d7/Android_robot.svg"
            alt="Android"
          />
        </div>

        <h1 className="androidDownloadTitle">
          {t('androidDownload.pageTitle')}
        </h1>

        <div className="androidDownloadNotice">
          <p>{t('androidDownload.notice')}</p>
        </div>

        <div className="androidDownloadSteps">
          <h2>{t('androidDownload.howToInstall')}</h2>
          <ol>
            <li>{t('androidDownload.step1')}</li>
            <li>{t('androidDownload.step2BrowserWarning')}</li>
            <li>
              {t('androidDownload.step2Before')}{' '}
              <Link
                to="/android-install-guide"
                className="androidInstallGuideLink"
              >
                {t('androidDownload.step2LinkText')}
              </Link>{' '}
              {t('androidDownload.step2After')}
            </li>
          </ol>
        </div>

        <a
          href={APK_URL}
          className="androidDownloadBtn"
          download
          rel="noopener noreferrer"
          onClick={() => trackAppDownload('android_download_apk', 'android')}
        >
          <img
            src={apkBadgeImg}
            alt={t('androidDownload.downloadBtnAlt')}
            className="androidDownloadBtnImg"
          />
        </a>

        <p className="androidDownloadVersion">
          {t('androidDownload.versionInfo')}
        </p>
      </div>
    </div>
    <Footer />
  </React.Fragment>
);

export default translate()(AndroidDownloadPage);
